import * as React from 'react';
import styled from 'styled-components';
import { Input } from '../General/Input';
import { rem } from 'polished';

export interface Props {
  name?: string;
  type?: string;
  placeholder?: string;
  value: string;
  onFocus: any;
  onChange: any;
  isMobile?: boolean;
  autoFocus?: any;
}

function SearchFormInput(props) {
  return <StyledInput {...props} />;
}

const StyledInput = styled(Input)`
  padding: ${rem(32)} ${rem(40)};
  font-size: ${rem(16)};
  line-height: ${rem(24)};
  font-weight: 500;
  max-width: initial;
  height: initial;
  box-shadow: none;
  border: none;
  outline: none;
  color: ${({ theme }) => theme.colors.textPrimary};

  &::placeholder {
    color: #888888;
  }

  &:focus {
    border: 0;
    outline: none;
  }

  ${({ theme }) => theme.mediab.l1150`
    padding-top: ${rem(24)};
    padding-bottom: ${rem(24)};

    // &::placeholder {
    //   color: transparent;
    //   opacity: 0;
    // }
  `}
`;

export { SearchFormInput };
